import React from 'react';
import { Scenario, Activity } from '@bingads-webui-react/hoc-with-signal';
import { ConversionTrackingCouponCallout } from './callout';

export const ConversionCallout = props => (
  <Scenario name="ConversionCallout">
    <Activity name="ShowConversionCallout">
      <ConversionTrackingCouponCallout {...props} />
    </Activity>
  </Scenario>
);

